import React from "react";
import dynamic from "next/dynamic";
import { getInitialData } from "../service/apiFetch";

const Videogallery = dynamic(() => import("../components/Gallery/Videogallery"), {
  ssr: false,
});

export const getStaticProps = async () => {
  const initialData = await getInitialData("video-gallery", {
    contentBlock: "Object",
  });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      url: initialData?.url || "",
      error: initialData?.error || "",
    },
  };
};

export default function VideogalleryPage({ data }) {
  return (
    <div>
      {data?.contentBlock?.VIDEO_GALLERY ? (
        <Videogallery data={data?.contentBlock?.VIDEO_GALLERY} />
      ) : (
        <p className="py-16 text-center text-gray-500">
          No video gallery data available.
        </p>
      )}
    </div>
  );
}
